import React, { useEffect, useState } from 'react';
import {
  Box,
  Typography,
  Grid,
  Table,
  TableRow,
  TableCell,
  TableBody,
} from '@mui/material';
import { useRecoilState, useRecoilValue } from 'recoil';
import { userInformationAtom } from '../../../Services/_states/auth.js';
import { ConstantActions } from '../../../Services/_actions/constant.actions';
import { HomeActions } from '../../../Services/_actions/home.action.js';
import OrganisationDropdown from '../../Shared/OrganisationDropdown/index.tsx';
import AccountsSection from './AccountsSection.tsx';
import ProposalsSection from './ProposalsSection.tsx';
import { selectedOrgDashboardAtom } from '../../Shared/selectedOrgDashboardAtom/index.js';
// import SearchableDropdown from '../../FlowBuilder/Common/SearchableDropdown/SearchableDropdown.tsx';
// import { ManagementActions } from '../../../Services/_actions/Management/management.actions.ts'; // Assuming this is where getOrganisationMapping is located

const OrganisationDashboardView: React.FC = () => {
  const constantActions = ConstantActions();
  const apiActions = HomeActions();
  // const managementActions = ManagementActions();
  const userInfo = useRecoilValue(userInformationAtom);

  const [orgFilters, setOrgFilters] = useState({ page: 1, limit: 10, search: '' });
  const [organisationResponse, setOrganisationResponse] = useState<{ list: any[], pages: number, count: number, has_next: boolean }>({ list: [], pages: 0, count: 0, has_next: false });
  const [selectedOrg, setSelectedOrg] = useRecoilState(selectedOrgDashboardAtom);
  // const [selectedOrg, setSelectedOrg] = useState<{ organisation_id: string, name: string } | null>(null);
  const [selectedAccount, setSelectedAccount] = useState(null);
  const [accounts, setAccounts] = useState<any[]>([]);
  const [proposals, setProposals] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);
  const [hasLoadedInitially, setHasLoadedInitially] = useState(false);

  // const fetchOrganisationMap = async (filterObj: { search?: string, page?: number, limit?: number }) => {
  //   setLoading(true);
  //   try {
  //     const res = await managementActions.getOrganisationMapping({ ...filterObj, organisation_id: userInfo?.profile?.organisation?.organisation_id });
  //     if (res?.status === 200) {
  //       const organisations = res.data?.list.map(item => item?.second_organisation);
  //       if (filterObj?.page === 1) {
  //         if (!hasLoadedInitially) {
  //           setSelectedOrg(userInfo?.profile?.organisation);
  //           setHasLoadedInitially(true);
  //         }

  //         setOrganisationResponse({ ...res.data, list: organisations ?? [] });
  //       } else {
  //         const existingList = organisationResponse?.list || [];
  //         const newList = organisations?.filter(
  //           newOrg => !existingList.some(org => org.organisation_id === newOrg.organisation_id)
  //         );
  //         setOrganisationResponse({
  //           ...res.data,
  //           list: [...existingList, ...newList]
  //         });
  //       }

  //     }
  //   } catch (error) {
  //     console.error('Error fetching organisation mapping:', error);
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  // Fetch Accounts
  const fetchAccounts = async (orgId: string) => {
    if (!orgId) return; // ✅ guard

    try {
      const res = await constantActions.getAccounts({ organisation_id: orgId });
      if (res?.status === 200) {
        const accountsData = res.data?.list || res.data || [];
        setAccounts(accountsData);
      } else {
        console.error('Error fetching accounts:', res?.data);
        setAccounts([]);
      }
    } catch (error) {
      console.error("Catch error:", error);
      setAccounts([]);
    }
  };
  // Fetch Proposals
  const fetchProposals = async (accountId: string) => {
    const res = await apiActions.getProposals({ account_id: accountId });
    if (res?.status === 200) {
      setProposals(res.data || []);  // Set proposals data
    } else {
      setProposals([]);  // Reset if no proposals
    }
  };

  // const loadMoreOrganisations = () => {
  //   if (organisationResponse?.has_next) {
  //     const nextPage = orgFilters.page + 1;
  //     setOrgFilters(prev => ({ ...prev, page: nextPage }));
  //     fetchOrganisationMap({ ...orgFilters, page: nextPage });
  //     //  setOrgFilters({ ...orgFilters, page: orgFilters.page + 1 });
  //     //  fetchOrganisationMap({ ...orgFilters, page: orgFilters.page + 1 });
  //   }
  // };

  // const handleSearch = (query: string = '') => {
  //   setOrgFilters(prev => ({ ...prev, page: 1, search: query }));
  //   fetchOrganisationMap({ ...orgFilters, page: 1, search: query });

  // };

  // useEffect(() => {
  //   fetchOrganisationMap(orgFilters);
  // }, []);

  // useEffect(() => {
  //   if (userInfo?.profile?.organisation?.organisation_id) {
  //     fetchOrganisationMap(orgFilters);
  //     console.log('Fetching organisation map');
  //   }
  // }, []);


  // Fetch accounts whenever the selected organisation changes
  useEffect(() => {
    if (selectedOrg?.organisation_id) {
      fetchAccounts(selectedOrg.organisation_id);
    }
  }, [selectedOrg]);


  // Fetch proposals whenever an account is selected
  // useEffect(() => {
  //   if (selectedAccount) {
  //     fetchProposals(selectedAccount); // Fetch proposals for selected account
  //   }
  // }, [selectedAccount]);
  useEffect(() => {
    if (userInfo?.profile?.organisation && !selectedOrg) {
      setSelectedOrg(userInfo.profile.organisation);
    }
  }, [userInfo]);

  // useEffect(() => {
  //   if (userInfo?.profile?.organisation) {
  //     setSelectedOrg(userInfo.profile.organisation);
  //   }
  // }, [userInfo]);

  // Handle Organisation Selection
  const onSelectOrganisation = (org: any) => {
    setSelectedOrg(org);
    setSelectedAccount(null);
    setProposals([]);  // Reset proposals when organisation changes
    setAccounts([]);   // Reset accounts when organisation changes
  };

  // Handle Account Selection
  const onSelectAccount = (account: any) => {
    setSelectedAccount(account);
    fetchProposals(account);  // Fetch proposals for selected account
  };

  return (
    <Box p={"5px"} sx={{ backgroundColor: 'white', borderRadius: 2 }}>
      <Grid container alignItems="center" mb={2}>
        <Grid item xs={12} md={9}>
          <Typography variant="h5" fontWeight="bold">
            Organisation Dashboard
          </Typography>
        </Grid>
        {/* <Grid item xs={12} md={3} sx={{ pl: 1 }}>
          <SearchableDropdown
            label="Organisation"
            value={selectedOrg}
            options={organisationResponse?.list || []}
            onChange={onSelectOrganisation}
            labelKey="name"
            valueKey="organisation_id"
            onSearch={handleSearch}
            loading={loading}
            size="small"
            searchValue={orgFilters?.search}
            fetchMoreOptions={loadMoreOrganisations}
          />
        </Grid> */}
        <Grid item xs={12} md={3} sx={{ pl: 1 }}>
          <OrganisationDropdown
            label="Organisation"
            value={selectedOrg}
            onChange={onSelectOrganisation}
            // autoSelectValue={false}
            sx={{ mb: 0, mt: 0 }}
          />
        </Grid>
      </Grid>

      {selectedOrg && (
        <>
          <Typography variant="h6" color="dark" gutterBottom>
            Organisation Details
          </Typography>
          <Table size="small">
            <TableBody>
              {(() => {
                const fields = [
                  { label: 'Name', value: selectedOrg.name },
                  { label: 'Category', value: selectedOrg.category },
                  { label: 'Phone', value: selectedOrg.phone },
                  { label: 'Email', value: selectedOrg.email },
                  { label: 'Address', value: selectedOrg.address },
                  { label: 'Comments', value: selectedOrg.comments },
                  { label: 'Reference Name', value: selectedOrg.reference_name },
                  { label: 'Reference Phone', value: selectedOrg.reference_phone },
                  { label: 'Reference Email', value: selectedOrg.reference_email }
                ].filter(f => !!f.value && f.value.trim() !== '');

                const rows = [];
                for (let i = 0; i < fields.length; i += 2) {
                  rows.push(fields.slice(i, i + 2));
                }

                return rows.map((pair, idx) => (
                  <TableRow key={idx}>
                    {pair.map((field, index) => (
                      <React.Fragment key={index}>
                        <TableCell sx={{ fontWeight: 'bold', width: '15%' }}>{field.label}</TableCell>
                        <TableCell sx={{ width: '35%' }}>{field.value}</TableCell>
                      </React.Fragment>
                    ))}
                    {pair.length === 1 && (
                      <><TableCell /><TableCell /></>
                    )}
                  </TableRow>
                ));
              })()}
            </TableBody>
          </Table>

          <Box mt={4}>
            <AccountsSection
              accounts={accounts}
              organisation={selectedOrg}
              onAccountCreated={() => fetchAccounts(selectedOrg?.organisation_id || '')}
              onAccountSelect={onSelectAccount}  // Passing the account selection function
            />
          </Box>

          <Box mt={2}>
            <ProposalsSection proposals={proposals} selectedOrganisation={selectedOrg} selectedAccount={selectedAccount} />  {/* Ensure proposals are passed here */}
          </Box>
        </>
      )}
    </Box>
  );
};

export default OrganisationDashboardView;
